import { useParams } from 'react-router-dom';
import CollectionDetails from './containers/CollectionDetails';
import PageContainer from '@/components/ui/containers/PageContainer';

function CollectionPage() {
    const { collectionId } = useParams<{ collectionId: string }>();

    if (!collectionId) {
        return <div>Collection not found.</div>;
    }

    return (
        <PageContainer>
            <CollectionDetails collectionId={collectionId} />
        </PageContainer>
    );
}

export default CollectionPage; 